"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const de = {
    'landing.nav.about': 'Über das System',
    'landing.nav.modules': 'Module',
    'landing.nav.assistants': 'KI-Assistenten',
    'landing.nav.contentStudio': 'Content Studio',
    'landing.nav.analytics': 'Analytik',
    'landing.nav.login': 'Anmelden',
    'landing.hero.eyebrow': 'KI-Plattform für Unternehmen',
    'landing.hero.title1': 'Ein Dashboard.',
    'landing.hero.title2': 'Alle KI-Modelle',
    'landing.hero.title3': 'Ihres Unternehmens.',
    'landing.hero.lede': 'IntHub vereint GPT-5, Claude, Gemini und DeepSeek an einem Ort — zusammen mit Assistenten, Content-Planung, Kostenberichten und Team-Management. Kein Wechseln zwischen einem Dutzend Tools.',
    'landing.hero.ctaLogin': 'Zum Panel anmelden',
    'landing.hero.ctaModules': 'Module ansehen',
    'landing.hero.note': 'testhub.intgate.io — Panel für angemeldete Unternehmen verfügbar',
    'landing.hero.deviceTitle': 'Beginnen Sie die Konversation mit Ihrem KI-Assistenten',
    'landing.hero.deviceSub': 'Wählen Sie Modell, Schreibstil und verbinden Sie Wissen — mit einem Befehl.',
    'landing.hero.deviceInput': '/ Stil · # Projekt · @ Wissen — geben Sie Ihre Frage ein…',
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    'landing.intro.eyebrow': 'Einführung',
    'landing.intro.title': 'Kommandozentrale für KI in der gesamten Organisation',
    'landing.intro.lede1': 'Statt die Arbeit auf Dutzende Tabs zu verteilen, sammelt IntHub KI-Modell-Gespräche, virtuelle Assistenten, Content-Planung und Kostenberichte in einem System. Jedes Unternehmen arbeitet in seinem eigenen Raum — mit eigenen Nutzern, Rollen, Kreditbudget und Modellen.',
    'landing.intro.lede2': 'Das System ist von Grund auf mandantenfähig: Ein Administratorkonto kann mehrere Unternehmen, Branchen und Teams verwalten, und jede Datenbankoperation wird in einem Audit-Protokoll erfasst.',
    'landing.stat.providers': '4 Anbieter',
    'landing.stat.providersLab': 'OpenAI, Anthropic, DeepSeek, Google — eine Chat-Oberfläche',
    'landing.stat.roles': '3 Rollen',
    'landing.stat.rolesLab': 'Super Admin, Manager, Benutzer — präzise Berechtigungen',
    'landing.stat.multitenant': 'Mandantenfähig',
    'landing.stat.multitenantLab': 'Mehrere Unternehmen, Branchen und Teams in einem System',
    'landing.stat.credits': 'Kredite',
    'landing.stat.creditsLab': 'KI-Nutzung abrechnen in einem transparenten Abo-Modell',
    'landing.modules.eyebrow': 'Module',
    'landing.modules.title': 'Was Sie genau in IntHub finden',
    'landing.modules.lede': 'Neun Module, ein Login. Jedes deckt eine andere Phase der KI-Arbeit im Unternehmen ab — vom Gespräch bis zur Abrechnung.',
    'landing.module.chat.title': 'Multi-Modell KI-Chat',
    'landing.module.chat.desc': 'Chatten Sie mit GPT-5, Claude, Gemini oder DeepSeek aus einem Fenster. Mit "/" wechseln Sie den Schreibstil, "#" verbindet ein Projekt, "@" die Wissensbasis — kein Tab-Wechsel.',
    'landing.module.assistants.title': 'Virtuelle Assistenten',
    'landing.module.assistants.desc': 'Erstellen Sie Avatare mit eigener Persönlichkeit, Geschlecht und KI-Modell. Jeder durchläuft eine Schulungsliste und erhält eine eigene Wissensbasis vor dem Einsatz.',
    'landing.module.knowledge.title': 'Wissensdatenbank',
    'landing.module.knowledge.desc': 'Verbinden Sie Unternehmensdokumente und Daten mit einem bestimmten Assistenten oder Projekt, damit Antworten auf Fakten Ihres Unternehmens basieren, nicht auf Allgemeinplätzen.',
    'landing.module.contentStudio.title': 'Content Studio',
    'landing.module.contentStudio.desc': 'Planen Sie Beiträge, weisen Sie Kanäle zu und verfolgen Sie den Status vom Entwurf bis zur Veröffentlichung. KI-Assistent schlägt Themen, Content-Pläne und beste Veröffentlichungszeiten vor.',
    'landing.module.styles.title': 'Schreibstile',
    'landing.module.styles.desc': 'Speichern Sie die Markenstimme — von formell wie in Berufskorrespondenz bis zu Jugendslang — und teilen Sie sie mit dem ganzen Team per einem Klick.',
    'landing.module.costs.title': 'Kostenberichte',
    'landing.module.costs.desc': 'Verfolgen Sie Token, Kosten pro Nachricht und aktivste Avatare aufgeschlüsselt nach Benutzer, Unternehmen und Zeitraum — mit Live-Trenddiagramm.',
    'landing.module.management.title': 'Unternehmens- & Team-Management',
    'landing.module.management.desc': 'Führen Sie mehrere Unternehmen mit separaten Modulen, Branchen und Berufen. Weisen Sie jedem Konto Rollen zu: Super Admin, Manager oder Benutzer.',
    'landing.module.logs.title': 'Audit-Protokolle & Zugriffe',
    'landing.module.logs.desc': 'Jedes Erstellen und Aktualisieren einer Konversation, Nachricht oder Wechselkurses wird im Datenbank-Protokoll erfasst — mit voller Ansicht der Eingabedaten und des Ergebnisses.',
    'landing.module.pricing.title': 'Pläne & Zahlungen',
    'landing.module.pricing.desc': 'Vom kostenlosen Plan bis Ultra ohne Limits — Benutzer, Avatare und Funktionen wachsen mit Ihrem Unternehmen, abgerechnet in monatlichen Krediten.',
    'landing.assistants.eyebrow': 'KI-Assistenten',
    'landing.assistants.title': 'Ein Bot-Team, das mit Ihrem Unternehmen wächst',
    'landing.assistants.lede': 'Jeder Assistent ist ein separater KI-Mitarbeiter: eigenes Modell, Persönlichkeit, Geschlecht und Wissensbereich.',
    'landing.assistants.feature1': 'Beliebiges Modell für jeden Avatar — Claude, DeepSeek, Gemini',
    'landing.assistants.feature2': 'Schulungsliste vor dem Einsatz',
    'landing.assistants.feature3': 'Eigene Wissensbasis und Listen- oder Rasteransicht der Assistenten',
    'landing.avatar.historian': 'Historiker',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'HIVE-Assistent',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · Entwickler',
    'landing.avatar.communicator': 'Kommunikator',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': 'Konfiguration abgeschlossen',
    'landing.cs.eyebrow': 'Content Studio',
    'landing.cs.title': 'Von der Idee zur Veröffentlichung, ohne Tabellen',
    'landing.cs.lede': 'Die Beitragsbibliothek zeigt, was Entwurf ist, was auf Genehmigung wartet und was bereits live ist. Fragen Sie den KI-Assistenten nach einem Thema, Wochenplan oder bestem Veröffentlichungszeitpunkt.',
    'landing.cs.feature1': 'Status: Entwurf, geplant, zur Genehmigung, veröffentlicht',
    'landing.cs.feature2': 'Zeitplan und Veröffentlichungsverlauf an einem Ort',
    'landing.cs.feature3': 'KI-Assistent schlägt Themen basierend auf Engagement vor',
    'landing.cs.statScheduled': 'Geplant (7 Tage)',
    'landing.cs.statApproval': 'Zur Genehmigung',
    'landing.cs.statPublished': 'Veröffentlicht (30 Tage)',
    'landing.cs.statTotal': 'Beiträge gesamt',
    'landing.cs.postTitle': 'API testen',
    'landing.cs.postStatus': 'Veröffentlicht',
    'landing.cs.postContent': '"Hallo! Heute zeigen wir, wie man eine API Schritt für Schritt testet…"',
    'landing.cs.suggest1': 'Welche Themen bringen das beste Engagement?',
    'landing.cs.suggest2': 'Schlagen Sie einen Content-Plan für nächste Woche vor',
    'landing.cs.suggest3': 'Wann ist der beste Zeitpunkt zum Veröffentlichen?',
    'landing.analytics.eyebrow': 'Analytik',
    'landing.analytics.title': 'Jeder Token bis auf den Cent abgerechnet',
    'landing.analytics.lede': 'Filtern Sie Kostenberichte nach Datum, Benutzer, Avatar oder Unternehmen.',
    'landing.analytics.feature1': 'Filter nach Datum, Benutzer, Avatar und Unternehmen',
    'landing.analytics.feature2': 'Kosten- und Token-Trenddiagramm über die Zeit',
    'landing.analytics.feature3': 'Ranking des aktivsten Avatars im Unternehmen',
    'landing.analytics.totalCost': 'Gesamtkosten',
    'landing.analytics.tokens': 'Token',
    'landing.analytics.messages': 'Nachrichten',
    'landing.analytics.avgCost': 'Ø Kosten / Nachricht',
    'landing.analytics.topMessages': 'Top-Avatar-Nachrichten',
    'landing.analytics.topAvatar': 'Top-Avatar',
    'landing.management.eyebrow': 'Verwaltung & Sicherheit',
    'landing.management.title': 'Mandantenstruktur, Kontrolle auf jeder Ebene',
    'landing.management.lede': 'Eine Installation verwaltet mehrere Unternehmen, Branchen und Berufe — und jede Änderung wird protokolliert.',
    'landing.management.companies.title': 'Unternehmen, Benutzer, Rollen',
    'landing.management.companies.desc': 'Fügen Sie Unternehmen mit NIP, Adresse und zugewiesenen Modulen hinzu. Weisen Sie jedem Konto eine Rolle zu.',
    'landing.management.logs.title': 'Audit-Protokolle der Datenbank',
    'landing.management.logs.desc': 'Filtern Sie Protokolle nach Datum, Modell und Operationstyp.',
    'landing.management.table.company': 'Unternehmen',
    'landing.management.table.city': 'Stadt',
    'landing.management.table.status': 'Status',
    'landing.management.table.model': 'Modell',
    'landing.management.table.operation': 'Operation',
    'landing.management.table.date': 'Datum',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': 'Warschau',
    'landing.management.krakow': 'Krakau',
    'landing.management.elk': 'Ełk',
    'landing.management.active': 'Aktiv',
    'landing.management.opConversation': 'Konversation',
    'landing.management.opMessage': 'Nachricht',
    'landing.management.opCurrency': 'Wechselkurs',
    'landing.management.opCreate': 'Erstellen',
    'landing.management.opUpdate': 'Aktualisieren',
    'landing.cta.eyebrow': 'Bereit zum Start',
    'landing.cta.title': 'Zentralisieren Sie KI in Ihrem Unternehmen noch heute',
    'landing.cta.lede': 'Melden Sie sich im Testpanel an und konfigurieren Sie Ihren ersten Assistenten in Minuten.',
    'landing.cta.button': 'Zum Login',
    'landing.footer.copyright': '© 2026 IntHub. Alle Rechte vorbehalten.',
    'landing.footer.panel': 'Login-Panel',
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'Arbeitsplatz mit KI',
};
exports.default = de;
